import store from 'data/redux/store'
import notificationsReducer from './reducer'

store.reducerManager.add('notifications', notificationsReducer)

export default store
